module.exports = __webpack_public_path__ + "img/transparent-nav-right-lincoln.bab869e4.png";